<breadcrumb-navigation [titles]="[{ key: 'MY_ACCOUNT', url: '/user/my-account'}, { key: 'SOLD_TO_DETAIL', url: ''}]"></breadcrumb-navigation>

<div class="my-account__container">
  <div class="my-account__module  mx:py-4 sm:py-4">
    <div class="subtitle">{{ 'SOLD_TO_DETAIL' | translate }}</div>
    <div class="my-account__organization">
      <div class="my-account__organization-title">
        <svg-icon [iconName]="'my-info.svg'" class="mr-2.5" [size]="48"></svg-icon>
        <span class="">{{ 'BASIC_INFORMATION' | translate }}</span>
      </div>
      <div class="my-account__organization-content sm:px-0 mx:px-14">
        <div class="info-row sm:block mx:flex mx:mb-8">
          <div class="info-item">
            <span class="label">{{ 'SOLD_TO_NO' | translate }}</span>
            <span class="value">{{ customerData?.soldToNo || '--' }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ 'SOLD_TO_FULL_NAME' | translate }}</span>
            <span class="value">{{ customerData?.soldToName || '--' }}</span>
          </div>
        </div>
        <div class="info-row sm:block mx:flex">
          <div class="info-item">
            <span class="label">{{ 'SALES_AREA' | translate }}</span>
            <span class="value">{{ customerData?.salesArea || '--' }}</span>
          </div>
          <div class="info-item">
            <span class="label">{{ 'CH3_NAME' | translate }}</span>
            <span class="value">{{ customerData?.ch3Name || '--' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="my-account__organization">
      <div class="my-account__organization-title">
        <svg-icon [iconName]="'my-info.svg'" class="mr-2.5" [size]="48"></svg-icon>
        <span class="">{{ 'PAYER_INFORMATION' | translate }}</span>
      </div>
      <div class="my-account__organization-content sm:px-0 mx:px-14">
        <nz-table 
          class="e-shop-table" 
          style="width: 100%;"
          [nzData]="payerList" 
          #fixedTable 
          [nzFrontPagination]="false" 
          [nzScroll]="{ x: 'auto' }">
          <thead>
            <tr>
              <th [nzWidth]="'10%'">{{ 'PAYER_NO' | translate }}</th>
              <th [nzWidth]="'20%'">{{ 'PAYER_NAME' | translate }}</th>
              <th [nzWidth]="'10%'">{{ 'POSTAL_CODE' | translate }}</th>
              <th [nzWidth]="'10%'">{{ 'COUNTRY' | translate }}</th>
              <th [nzWidth]="'10%'">{{ 'CITY' | translate }}</th>
              <th [nzWidth]="'15%'">{{ 'STREET' | translate }}</th>
              <th [nzWidth]="'25%'">{{ 'PHONE' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of payerList">
              <td>{{data.customerCode}}</td>
              <td>{{data.customerName}}</td>
              <td>{{data.postalCode}}</td>
              <td>{{data.country}}</td>
              <td>{{data.city}}</td>
              <td>{{data.street}}</td>
              <td>{{data.mobilePhone}}</td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>

    <div class="my-account__organization">
      <div class="my-account__organization-title">
        <svg-icon [iconName]="'my-info.svg'" class="mr-2.5" [size]="48"></svg-icon>
        <span class="">{{ 'BILL_TO_INFORMATION' | translate }}</span>
      </div>
      <div class="my-account__organization-content sm:px-0 mx:px-14">
        <nz-table 
          class="e-shop-table" 
          style="width: 100%;"
          [nzData]="billList" 
          #fixedTable 
          [nzFrontPagination]="false" 
          [nzScroll]="{ x: 'auto' }">
          <thead>
            <tr>
              <th [nzWidth]="'10%'">{{ 'BILL_TO_NO' | translate }}</th>
              <th [nzWidth]="'20%'">{{ 'BILL_TO_NAME' | translate }}</th>
              <th [nzWidth]="'10%'">{{ 'POSTAL_CODE' | translate }}</th>
              <th [nzWidth]="'10%'">{{ 'COUNTRY' | translate }}</th>
              <th [nzWidth]="'10%'">{{ 'CITY' | translate }}</th>
              <th [nzWidth]="'15%'">{{ 'STREET' | translate }}</th>
              <th [nzWidth]="'25%'">{{ 'PHONE' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of billList">
              <td>{{data.customerCode}}</td>
              <td>{{data.customerName}}</td>
              <td>{{data.postalCode}}</td>
              <td>{{data.country}}</td>
              <td>{{data.city}}</td>
              <td>{{data.street}}</td>
              <td>{{data.mobilePhone}}</td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>

    <div class="my-account__organization">
      <div class="my-account__organization-title">
        <svg-icon [iconName]="'my-info.svg'" class="mr-2.5" [size]="48"></svg-icon>
        <span class="">{{ 'SHIP_TO_INFORMATION' | translate }}</span>
      </div>
      <div class="my-account__organization-content sm:px-0 mx:px-14">
        <nz-table 
          class="e-shop-table" 
          style="width: 100%;"
          [nzData]="shipList" 
          #fixedTable 
          [nzFrontPagination]="false" 
          [nzScroll]="{ x: 'auto' }">
          <thead>
            <tr>
              <th [nzWidth]="'10%'">{{ 'SHIP_TO_NO' | translate }}</th>
              <th [nzWidth]="'20%'">{{ 'SHIP_TO_NAME' | translate }}</th>
              <th [nzWidth]="'10%'">{{ 'POSTAL_CODE' | translate }}</th>
              <th [nzWidth]="'10%'">{{ 'COUNTRY' | translate }}</th>
              <th [nzWidth]="'10%'">{{ 'CITY' | translate }}</th>
              <th [nzWidth]="'15%'">{{ 'STREET' | translate }}</th>
              <th [nzWidth]="'15%'">{{ 'PHONE' | translate }}</th>
              <th [nzWidth]="'10%'">{{ 'SET_AS_DEFAULT' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of shipList">
              <td>{{data.customerCode}}</td>
              <td>{{data.customerName}}</td>
              <td>{{data.postalCode}}</td>
              <td>{{data.country}}</td>
              <td>{{data.city}}</td>
              <td>{{data.street}}</td>
              <td>{{data.mobilePhone}}</td>
              <td>
                <nz-switch [ngModel]="data.userDefault" (ngModelChange)="handleSetDefault($event, data.customerCode)"></nz-switch>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
  </div>
</div>

  




